import client from './client'

const apiBasePath = '/api/group/account/'

export default {
  search: entryForm => client.post(apiBasePath + 'search', entryForm),
  detail: entryForm => client.post(apiBasePath + 'detail', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm),
  delete: entryForm => client.post(apiBasePath + 'delete', entryForm)
}
